import { required, maxLength, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      name: {
        required: helpers.withMessage(i18n.global.t('Please enter a category name.'), required),
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Category name cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        )
      },
      // ชื่ออังกฤษ optional — ไม่กรอกก็ได้ ระบบจะ fallback ไปใช้ชื่อไทย
      name_en: {
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Category name cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        )
      },
      description: {},
      description_en: {},
      is_active: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      }
    }
  }
};
